module.exports = __webpack_public_path__ + "img/icon-service.1ff74fb.png";